import React from "react";
import "../../App.css";
import { Layout, Menu, Dropdown, Icon } from "antd";
// import log from '../../assets/logo.gif'
import logTW from "../../assets/logo-tw.png";
import logDL from "../../assets/logo-dl.png";
import lanPic from "../../assets/images/header-language.png";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { routes } from "../../routes";
import { withTranslation } from "react-i18next";
import i18n from "i18next";
const { Header } = Layout;
const title = [
  "服务云",
  "服務雲",
  "Digiwin Cloud Service Manager",
  "Đám mây dịch vụ Digiwin",
  "การบริการคลาวเซอร์วิส",
];
let url = window.location.host.toLowerCase();
let path=window.location.pathname.toLowerCase();
let twLocation = "es-ygj.digiwincloud.com"; //台湾
class HeaderEmpty extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyId: "",
      log: logDL,
      lan:lanPic
    };
  }
  componentDidMount() {
    setTimeout(() => {
      if(path=="/policy/cn" || path=="/policy/user/cn"){
        this.setState({
          keyId: "0"
        });
      }else if(path=="/policy/tw" || path=="/policy/user/tw"){
        this.setState({
          keyId: "1",
          log: logTW,
        });
      }else if(path=="/policy/vn" || path=="/policy/user/vn"){
        this.setState({
          keyId: "3"
        });
      }else if(path=="/policy/my" || path=="/policy/user/my"){
        this.setState({
          keyId: "2"
        });
      }else if(path=="/policy/th" || path=="/policy/user/th"){
        this.setState({
          keyId: "4"
        });
      }else{
        if (url === twLocation) {
          //台湾
          this.setState({
            keyId: "1",
            log: logTW,
          });
        }else{
          this.setState({
            keyId: "0",
            log: logDL,
          });
        }
      }
      this.changeLang(this.state.keyId);
      if(url === twLocation){
        if(this.state.keyId === "0"){
          document.title = "服务云";
        } else {
          document.title = title[this.state.keyId];
        }
      } else {
        if(this.state.keyId === "1"){
          document.title = "服務雲";
        }
        else {
          document.title = title[this.state.keyId];
        }
      }
      //document.title = title[this.state.keyId];
      
    }, 500);
  }
  changeLang(code) {
    let lan;
    switch (code) {
      case "0":
        lan = i18n.changeLanguage("zhCN");
        break;
      case "1":
        lan = i18n.changeLanguage("zhTW");
        break;
      case "2":
        lan = i18n.changeLanguage("zhEN");
        break;
      case "3":
        lan = i18n.changeLanguage("zhVN"); //越南
        break;
      case "4":
        lan = i18n.changeLanguage("zhTHAI"); //泰语
        break;
      default:
        lan = i18n.changeLanguage("zhCN");
    }
    console.log(lan);
  }
  render() {
    const {
      t,
      location: { pathname },
    } = this.props;
    return (
      <Header
        className="q-theme-header"
        style={{
          position: "fixed",
          zIndex: 3,
          width: "100%",
          backgroundColor: "#eaeaea",
          borderBottom: "1px solid #d9d9d9",
        }}
      >
        <div className="q-fix-width pr" style={{ height: "100%" }}>
          <div className="logo">
            <img className="logo-right" alt="" src={this.state.log} />
            {t("title")}
          </div>
          <div></div>
        </div>
      </Header>
    );
  }
}
export default withTranslation()(withRouter(HeaderEmpty));
